import WrapperService from "@/modules/core/services/wrapper-service";
import { createPageableParams } from "@/modules/core/services/table-utils";

const sortFacilityProcessResultFields = ["processName"];
const sortFacilityProcessResultDatabaseFields = ["p.name"];

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/process/result"

const serviceName = "ProcessResult-Service: ";

export default class ProcessResultService {
  static async readPageableFacilityProcessResultFromAPI(facilityId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortFacilityProcessResultFields, sortFacilityProcessResultDatabaseFields);
    await WrapperService.get(API_URL + "/facility/" + facilityId, { params: params }, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF)
  }

  static postToAPI(processResult, successF, errorF) {
    WrapperService.post(API_URL, processResult, serviceName, successF, errorF);
  }

  static putStepResultFromResultToAPI(resultId, processStepResult, successF, errorF) {
    WrapperService.put(API_URL + "/" + resultId + "/step/" + processStepResult.id, processStepResult, serviceName, successF, errorF)
  }

  static postQuickstartToAPI(processResult, successF, errorF) {
    WrapperService.post(API_URL + "/quickstart", processResult, serviceName, successF, errorF);
  }
}
